// Flag de "ya vio el aviso del canal de contacto nuevo", por psicóloga. Solo localStorage
// (sin persistencia server-side, decisión explícita): si entra desde otro dispositivo/navegador
// puede volver a verlo una vez — no vale la pena el desarrollo extra para evitarlo.
const SEEN_KEY_PREFIX = 'psi-contact-channel-notice-seen-';

export function hasSeenContactChannelNotice(psychologistId: string): boolean {
  if (!psychologistId) return true; // sin id no se puede persistir bien: no molestar
  try {
    return localStorage.getItem(SEEN_KEY_PREFIX + psychologistId) === '1';
  } catch {
    return true;
  }
}

export function markContactChannelNoticeSeen(psychologistId: string): void {
  try { localStorage.setItem(SEEN_KEY_PREFIX + psychologistId, '1'); } catch { /* noop */ }
}
